import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "title", "label", "image"];
import React from 'react';
import { useComponentTheme } from '../../../../../utils/hooks';
import { HEADER_NAVIGATION_MENU_CONTENT_HEADER_CLASS_PREFIX, headerNavigationMenuContentHeaderRoot } from './constants';
import { HeaderNavigationMenuContentHeaderRoot, MenuContentHeaderLabel, MenuContentHeader, MenuContentHeaderItem, MenuContentHeaderTitle } from './style';
import { useHeaderNavigationMenuContentHeaderClassName } from './hooks';
import { headerNavigationMenuContentHeaderTheme } from './theme';
export var HeaderNavigationMenuContentHeader = function HeaderNavigationMenuContentHeader(_ref) {
  var className = _ref.className,
      title = _ref.title,
      label = _ref.label,
      image = _ref.image,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var theme = useComponentTheme(HEADER_NAVIGATION_MENU_CONTENT_HEADER_CLASS_PREFIX, headerNavigationMenuContentHeaderTheme);
  var classOverride = useHeaderNavigationMenuContentHeaderClassName(HEADER_NAVIGATION_MENU_CONTENT_HEADER_CLASS_PREFIX, className);
  return React.createElement(HeaderNavigationMenuContentHeaderRoot, Object.assign({
    "data-testid": headerNavigationMenuContentHeaderRoot
  }, restProps, {
    theme: theme,
    className: classOverride.Root
  }), React.createElement(MenuContentHeader, {
    theme: theme,
    className: classOverride.HeaderNavigationMenuContentHeader
  }, React.createElement(MenuContentHeaderItem, {
    theme: theme,
    className: classOverride.HeaderNavigationMenuContentHeaderItem
  }, title ? React.createElement(MenuContentHeaderTitle, {
    label: true,
    small: true,
    theme: theme,
    className: classOverride.Title
  }, title) : null, label ? React.createElement(MenuContentHeaderLabel, {
    paragraph: true,
    medium: true,
    theme: theme,
    className: classOverride.Label
  }, label) : null), React.createElement(MenuContentHeaderItem, {
    theme: theme,
    className: classOverride.HeaderNavigationMenuContentHeaderItem
  }, image || null)));
};
HeaderNavigationMenuContentHeader.defaultProps = {};